import customAxios from "./axiosConfig";

const AccountantConnectionService = {
    getAccountantConnectionList: function(params) {
        let api_url = window.Urls["accountant_connection_list"]();
        return customAxios.get(api_url, {params: params});
    },
    disconnect: function(pk) {
        var data = {
            'status': 'disconnected',
            'last_status_change': new Date()
        };

        var api_url = window.Urls['accountant_connection_detail'](pk);
        return customAxios.patch(api_url, data);
    }
}

export default AccountantConnectionService;